export default "__VITE_ASSET__51659e95__"